import LocationSearchModal from "./locationSearchModal";

export default LocationSearchModal;